$.fn.VideoPlayer = function() {
  let self = this
  self.video = $(this).find('video').get(0)
  self.overlay = self.find('.video-player__overlay')
  self.play_pause = self.find('.video-player__pause-play')
  self.sound_mute = self.find('.video-player__sound-mute')
  self.progress = self.find('.video-player__progress-bar')

  self.play = true

  if (self.sound_mute.hasClass('--unmuted')) {
    self.sound = true
    self.video.muted = false
  } else {
    self.sound = false
  }

  if (self.play_pause.hasClass('--paused')) {
    self.play = false
    self.video.pause()
  } else {
    self.play = true
  }

  self.play_pause.click(function() {
    if (self.play) {
      self.video.pause()
      self.play_pause.addClass('--paused')
      self.addClass('--paused')
      self.play = false
    } else {
      self.video.play()
      self.play_pause.removeClass('--paused')
      self.removeClass('--paused')
      self.play = true
    }
  })

  self.overlay.click(function() {
    if (!self.play) {
      self.video.play()
      self.play_pause.removeClass('--paused')
      self.removeClass('--paused')
      self.play = true
    }
  })

  self.sound_mute.click(function() {
    if (self.sound) {
      self.video.muted = true
      self.sound_mute.removeClass('--unmuted')
      self.sound = false
    } else {
      self.video.muted = false
      self.sound_mute.addClass('--unmuted')
      self.sound = true
    }
  })

  setInterval(function () {
    if (typeof self.video != "undefined") {
      self.progress.css('--progress', Math.round(
        (self.video.currentTime / self.video.duration) * 100
      ) + '%')
    }
  }, 1000/30)
}

$.fn.VideoPlaylist = function() {
  let self = this
  self.find('.video-playlist__item:first-child').addClass('--current')
  self.find('.video-playlist__sound').click(function() {
    if ($(this).hasClass('--on')) {
      self.find('video').prop('muted', true)
      $(this).removeClass('--on')
    } else {
      self.find('video').prop('muted', false)
      $(this).addClass('--on')
    }
  })
  self.find('.video-playlist__play').click(function() {
    if ($(this).hasClass('--on')) {
      self.find('.--current').find('video')[0].play()
      $(this).removeClass('--on')
    } else {
      self.find('.--current').find('video')[0].pause()
      $(this).addClass('--on')
    }
  })
  self.find('.video-playlist__next').click(function() {
    var current = self.find('.--current')
    current.removeClass('--current')
    if (current.is(':last-child')) {
      var nextEl = self.find('.video-playlist__item:first-child')
    } else {
      var nextEl = current.next('.video-playlist__item')
    }
    nextEl.addClass('--current')
    nextEl.find('video')[0].play()
  })
  self.find('.video-playlist__prev').click(function() {
    var current = self.find('.--current')
    current.removeClass('--current')
    if (current.is(':first-child')) {
      var prevEl = self.find('.video-playlist__item:last-child')
    } else {
      var prevEl = current.prev('.video-playlist__item')
    }
    prevEl.addClass('--current')
    prevEl.find('video')[0].play()
  })
  self.find('.video-playlist__item').each(function() {
    let video_element = $(this)
    if (video_element.is(':last-child')) {
      video_element.nextEl = self.find('.video-playlist__item:first-child')
    } else {
      video_element.nextEl = video_element.next('.video-playlist__item')
    }
    if (video_element.is(':first-child')) {
      video_element.prevEl = self.find('.video-playlist__item:last-child')
    } else {
      video_element.prevEl = video_element.prev('.video-playlist__item')
    }
    video_element.find('video').removeAttr('loop')
    if ($(this).index() > 0) {
      video_element.find('video').removeAttr('autoplay')
      video_element.find('video').get(0).pause()
    }

    video_element.find('video').on("ended", function() {
      video_element.nextEl.addClass('--current')
      video_element.removeClass('--current')
      video_element.nextEl.find('video')[0].play()
    })

    video_element.find('video').on("play", function() {
      self.find('.video-playlist__play').removeClass('--on')
      if (video_element.hasClass('--current'))  {
        setTimeout(function() {
          video_element.nextEl.find('video')[0].load()
        }, 5000)
      } else {
        video_element.find('video')[0].pause()
      }
    })
  })
}
